/**
 * All dates are being received from backend as UTC+0
 * The only purpose of this service is to format dates from UTC+0 string into date
 * and from date into UTC+0 string representation
 *
 * As of this moment, date objects used across the application shall always be persistent in user agent's timezone.
 * Conversion into concrete timezone shall NOT be performed here
 */
abstract class IApiDateConverter {
    public abstract apiStringToDate(apiDateString: string) : Date;

    public abstract dateToAPIString(dateObject: Date, timezone?: string): string;
}

export { IApiDateConverter };